@if (data$ | async; as data) {
  <div class="relative flex flex-col w-screen h-screen">
    @if (data.modalOpened) {
      <div class="absolute  top-0 w-full h-full left-0 overlay-container animate__animated animate__fast animate__fadeIn">
        <div class="w-full h-full relative flex flex-col items-center justify-center p-4" (click)="closeModal()">
          <div class="absolute top-4 right-4" style="z-index: 40;">
            <button class="text-white-100">
              <i-tabler name="x"></i-tabler>
            </button>
          </div>
          @if (data.modalResource) {
            <app-modal-content (click)="$event.preventDefault(); $event.stopPropagation()"
              [resource]="data.modalResource"
            [type]="data.modalResourceType"></app-modal-content>
          }
        </div>
      </div>
    }
    <div #pageContainer class="grow min-w-0 h-full overflow-y-auto">
      <app-nav-bar appScrolling class="absolute w-full z-10 top-[10px]" [currentRoute]="data.currentRoute" [menuItems]="menuItems"></app-nav-bar>
      @if (data.sidebarOpened && data.isSmallScreen) {
        <app-side-bar
          class="absolute w-full h-full block lg:hidden z-20 right-0 left-0 top-0 bottom-0"
          [menuItems]="menuItems"
          [currentRoute]="data.currentRoute"
        [sidebarState]="'in'"></app-side-bar>
      }
      <router-outlet></router-outlet>
      <app-footer
        [isSmallScreen]="data.isSmallScreen"
        [footerImages]="footerImages">
      </app-footer>
    </div>
    @if (toasty$ | async; as toasty) {
      <div class="toasty-container animate__animated animate__faster animate__fadeIn">
        <xos-toasty [toasty]="toasty"></xos-toasty>
      </div>
    }
  </div>
}
